// extracted by mini-css-extract-plugin
export default {"departments":"yF-z","departmentHeading":"zF-z","departmentSection":"AF-z","departmentName":"BF-z","departmentLink":"CF-z","expandIcon":"DF-z"};